const mediaItems = [
  {
    title: '流浪地球3：星际远征',
    desc: '人类文明的终极抉择，史诗科幻巨制',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20distant%20galaxy%20and%20spaceships%2C%20dramatic%20lighting%20with%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20atmospheric%20deep%20space%20background%2C%20movie%20poster%20aesthetic%2C%20high%20contrast%20and%20mysterious%20mood&width=800&height=450&seq=media-01&orientation=landscape',
    tag: '科幻',
    duration: '02:35',
  },
  {
    title: '长安十二时辰：烽火连城',
    desc: '盛唐暗涌，一场惊心动魄的权谋',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20night%20with%20lanterns%20and%20moonlight%2C%20Tang%20dynasty%20aesthetic%2C%20dramatic%20shadows%20and%20warm%20golden%20glow%2C%20cinematic%20composition%20with%20mysterious%20atmosphere%2C%20historical%20drama%20movie%20poster%20style&width=800&height=450&seq=media-02&orientation=landscape',
    tag: '古装',
    duration: '01:48',
  },
  {
    title: '乘风破浪的姐姐：逆风翻盘',
    desc: '用实力打破定义，姐姐们的高光舞台',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20performance%20with%20spotlights%20and%20smoke%20effects%2C%20energetic%20atmosphere%20with%20warm%20amber%20and%20gold%20lighting%2C%20concert%20aesthetic%2C%20music%20show%20poster%20style%2C%20dynamic%20composition%20with%20silhouettes&width=800&height=450&seq=media-03&orientation=landscape',
    tag: '综艺',
    duration: '03:12',
  },
  {
    title: '地球脉动3：深海奇境',
    desc: '潜入神秘深海，探访未知生命奇迹',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20deep%20ocean%20scene%20with%20bioluminescent%20creatures%20and%20ethereal%20blue-green%20lighting%2C%20mysterious%20underwater%20atmosphere%2C%20nature%20documentary%20aesthetic%2C%20cinematic%20composition%20with%20rays%20of%20light%20penetrating%20deep%20water&width=800&height=450&seq=media-04&orientation=landscape',
    tag: '纪录',
    duration: '04:05',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩预告</h2>
            <p className="mt-3 text-sm text-foreground-500">热门影片预告抢先看</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item) => (
              <div key={item.title} className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
                <div className="relative overflow-hidden aspect-video">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-foreground-900/20 group-hover:bg-foreground-900/10 transition-colors"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center backdrop-blur-sm transition-transform group-hover:scale-110">
                      <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-50/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">
                    {item.tag}
                  </span>
                  <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-foreground-900/60 text-background-50 text-xs backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}